import { render, staticRenderFns } from "./TeacherPageCard.vue?vue&type=template&id=39364140&"
import script from "./TeacherPageCard.vue?vue&type=script&lang=js&"
export * from "./TeacherPageCard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPageCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeacherPageCard.vue"
export default component.exports